import React from "react";
import { NewDynamicTab } from "../../../components/Page";
import { JvvnlTitle } from "../Jvnnl_Dashboard";
import JvvnlGlobalSearch from "../../../components/Search/Jvvnl/GlobalSearch";
import DgitalTwinPage from "./DigitalTwinPage";

const DigitalTwin = () => {
  return (
    <NewDynamicTab
      rightPrefixComponent={<JvvnlGlobalSearch />}
      header="Grid Replica"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      showDates={false}
      tabs={{
        DigialTwin: <DgitalTwinPage />,
      }}
    />
  );
};

export default DigitalTwin;
